import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View, Waiting } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectUserId, selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { fetchKanbanBoard, fetchKanbanBoardColumnCells, performAction, refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { FormField } from '../../../../components/FormFields';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox } from '../../../../components/Box';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { selectUser } from '../../../Users/selectors';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Transport_1_takeout.module.css';

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
`;

const STATE = {
  approve: false,
};

let todaydate = new Date().toISOString();

/* eslint-disable react/prefer-stateless-function */
class Transport_1_takeoutComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (this.props.work) return null;
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.Transport_1_takeout.modal.title')}>
        <h6 className="mb-2">Klaarzetten:</h6>

        <h5 className="mb-2">
          {' '}
          {this.lbl(`vehicle.property.task_move_car_for_takeout.${this.vehicle.task_move_car_for_takeout}`)}
        </h5>
        <div>
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.props.confirm(this.reset.bind(this))}>
                {this.lbl('done')}
              </ButtonComponent>
            </>
          )}
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader
            vehicle={vehicle}
            statusLabel={
              <VehicleStatusLabel status={vehicle.status}>
                {this.lbl(`vehicle.property.task_move_car_for_takeout.${vehicle.task_move_car_for_takeout}`)}
              </VehicleStatusLabel>
            }
          />
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>

              </div>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
        <HBox style={{fontSize:"12px"}} onClick={this.tofn(`/vehicles/${vehicle.id}`)} >{vehicle.id} </HBox>
      </Cell>
    );
  }
}

Transport_1_takeoutComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE_PROPERTY_UPDATE + '-task_move_car_for_takeout']),
    userId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    confirm(callback) {
      dispatch(
        setVehicleProperty(ownProps.cell.vehicle.id, 'task_move_car_for_takeout', 'done', () => {
          dispatch(fetchKanbanBoardColumnCells(ownProps.board_id, ownProps.column.id, callback));
          dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'transport_outgoing_takeout_completed_date', todaydate));
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_1_takeout = compose(withConnect, withRouter)(Transport_1_takeoutComp);
